/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Termsagreed_Commitmentamount_Description3Inputs */

const en_coinvestments_termsagreed_commitmentamount_description3 = /** @type {(inputs: Coinvestments_Termsagreed_Commitmentamount_Description3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Final commitment confirmed at deal close`)
};

/**
* | output |
* | --- |
* | "Final commitment confirmed at deal close" |
*
* @param {Coinvestments_Termsagreed_Commitmentamount_Description3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_termsagreed_commitmentamount_description3 = /** @type {((inputs?: Coinvestments_Termsagreed_Commitmentamount_Description3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Termsagreed_Commitmentamount_Description3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_termsagreed_commitmentamount_description3(inputs)
});
export { coinvestments_termsagreed_commitmentamount_description3 as "coInvestments_termsAgreed_commitmentAmount_description" }